import { BaseAPIClient } from "./baseApi";

const POST = "POST";
const GET = "GET";
const PUT = "PUT";
const PATCH = "PATCH";
const DELETE = "DELETE";

export class PitchApi extends BaseAPIClient {
  validateEmail(email) {
    return this.call("/check-email", GET, email);
  }

  signIn(credentials) {
    return this.call("/sign-in", POST, credentials);
  }

  signUp(customerData) {
    return this.call("/sign-up", POST, customerData);
  }

  requestRecoverPassword(email) {
    return this.call("/recover", POST, { email });
  }

  validateOtp(otp) {
    return this.call(`/valid/${otp}`, GET);
  }

  updatePassword(data) {
    return this.call("/password", POST, data);
  }

  activateAccount(id) {
    return this.call(`/validate-email/${id}`, GET);
  }

  showProfile() {
    return this.call("/profile", GET);
  }

  getDashboard() {
    return this.call("/dashboard", GET);
  }

  getWallet() {
    return this.call("/wallet", GET);
  }

  getFinance(params) {
    return this.call("/finance", GET, params);
  }

  removerDisponibilidade(id) {
    return this.call(`/profile/update/${id}`, DELETE);
  }

  updateProfile(data) {
    return this.call("/profile", PUT, data);
  }

  getPartnerPlans() {
    return this.call("/plans", GET);
  }

  createPartnerPlan(data) {
    return this.call("/plans", POST, data);
  }

  updatePartnerPlan(id, data) {
    return this.call(`/plans/${id}`, PUT, data);
  }

  getNotifications(page) {
    return this.call(`/notifications?page=${page}&size=10`, GET);
  }

  getUnreadNotificationsCount() {
    return this.call("/notifications/unread-count", GET);
  }

  readNotification(id) {
    return this.call(`/notifications/${id}`, PUT);
  }

  getStudyGroups() {
    return this.call("/groups", GET);
  }

  getOneStudyGroups(id) {
    return this.call("/groups/" + id, GET);
  }

  getStudyGroupAttendance(id, params) {
    return this.call(`/groups/${id}/attendance`, GET, params);
  }

  updateStudyGroupAttendance(groupId, data) {
    return this.call(`/groups/${groupId}/attendance`, PUT, data);
  }

  getGroupLessonRoster(groupId, params) {
    return this.call(`/groups/${groupId}/lessons`, GET, params);
  }

  saveLessonAttendance(groupId, eventId, data) {
    return this.call(
      `/groups/${groupId}/attendance/lesson/${eventId}`,
      PUT,
      data
    );
  }

  updateStudentEnglishLevel(groupId, studentId, data) {
    return this.call(
      `/groups/${groupId}/students/${studentId}/level`,
      PUT,
      data
    );
  }

  updateStudentBilling(groupId, studentId, data) {
    return this.call(
      `/groups/${groupId}/students/${studentId}/billing`,
      PUT,
      data
    );
  }

  listStudyGroups() {
    return this.call("/groups", GET);
  }

  listGroupMonthlyCharges(groupId, params = {}) {
    return this.call(`/groups/${groupId}/monthly-charges`, GET, params);
  }

  updateGroupMonthlyCharge(groupId, chargeId, data) {
    return this.call(
      `/groups/${groupId}/monthly-charges/${chargeId}`,
      PUT,
      data
    );
  }

  updateGroupChargeStatus(groupId, chargeId, status) {
    return this.call(
      `/groups/${groupId}/monthly-charges/${chargeId}/status`,
      PATCH,
      { status }
    );
  }

  udpateRequest(id, data) {
    return this.call(`/groups/${id}`, PUT, data);
  }

  updateRequest(id, data) {
    return this.udpateRequest(id, data);
  }

  listCourseContent() {
    return this.call("/course", GET);
  }

  getCourseById(id) {
    return this.call(`/course/${id}`, GET);
  }

  getCourseContent(module, id) {
    return this.call(`/course/${module}/${id}`, GET);
  }

  calendar() {
    return this.call(`/calendar`, GET);
  }

  createComplementaryClass(data) {
    return this.call(`/calendar/events`, POST, data);
  }

  postergate(id, data) {
    return this.call(`/calendar/events/${id}`, PUT, data);
  }

  cancelarAula(id, motivo) {
    return this.call(`/calendar/events/${id}/cancel`, PUT, motivo);
  }

  adiarParaProxima(id, data) {
    return this.call(`/calendar/events/${id}/next`, PUT, { data });
  }

  getClassContentByLevel(level) {
    return this.call(`/content/by-level`, GET, { level });
  }

  rearrange(eventId, classId) {
    return this.call(`/calendar/events/${eventId}/${classId}/rearrange`);
  }

  confirmClass(eventId) {
    return this.call(`/calendar/events/confirm/${eventId}`, PUT);
  }

  vote(id, option) {
    return this.call(`/calendar/vote/${id}`, POST, { agreed: option });
  }

  updateStudyGroupLevel(groupId, data) {
    return this.call(`/groups/${groupId}/level`, PUT, data);
  }

  updateStudyGroupFormat(groupId, data) {
    return this.call(`/groups/${groupId}/format`, PUT, data);
  }

  updateStudentLevel(groupId, customerId, data) {
    return this.call(
      `/groups/${groupId}/students/${customerId}/level`,
      PUT,
      data
    );
  }

  listGroupAttendance(groupId, customerId, params = {}) {
    return this.call(`/groups/${groupId}/attendance`, GET, {
      customerId,
      ...params,
    });
  }

  markStudentAttendance(groupId, eventId, data) {
    return this.call(`/groups/${groupId}/attendance/${eventId}`, PUT, data);
  }

  setStudentLessonCompletion(groupId, eventId, customerId, completed) {
    return this.call(`/groups/${groupId}/lessons/${eventId}/complete`, PUT, {
      customerId,
      completed,
    });
  }

  updateLessonSubject(groupId, eventId, courseClassId) {
    return this.call(`/groups/${groupId}/lessons/${eventId}/subject`, PUT, {
      courseClassId,
    });
  }

  getStudentSubjectSequence(groupId, customerId) {
    return this.call(`/groups/${groupId}/students/${customerId}/progress`, GET);
  }

  setStudentSubjectProgress(groupId, customerId, data) {
    return this.call(
      `/groups/${groupId}/students/${customerId}/progress`,
      PUT,
      data
    );
  }

  getPartnerFinance(params = {}) {
    return this.call("/finance", GET, params);
  }

  updateBankAccount(payload) {
    return this.call("/bank-account", PUT, payload);
  }
}

const api = new PitchApi(process.env.VUE_APP_PITCH_API_PARTNER);

export default api;
